import axios from 'axios'
const { STD_API_URL } = process.env

const studentRequest = axios.create({
  baseURL: STD_API_URL || 'https://example.com/', // API server url
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  maxContentLength: 100 * 1024 * 1024,
  maxBodyLength: 100 * 1024 * 1024,
  // Increase timeout for large uploads
  timeout: 180000, // 3 minutes
})

export default studentRequest
